import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/admin`,
});

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

// ── Existing ──────────────────────────────────────────────────────────────────

export async function getAllRideByAdmin(payload) {
  try {
    const res = await API.post("/get-all-rides", payload, {
      headers: authHeader(),
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// ── Admin Book Ride ───────────────────────────────────────────────────────────

/**
 * Fare estimate between pickup and drop
 * @param {{ pickupLat, pickupLng, dropLat, dropLng }} payload
 */
export async function getFareEstimate(payload) {
  try {
    const res = await API.post("/book-ride/fare-estimate", payload, {
      headers: authHeader(),
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

/**
 * Nearby online drivers for pickup location
 * @param {{ pickupLat, pickupLng }} payload
 */
export async function getNearbyDrivers(payload) {
  try {
    const res = await API.post("/book-ride/nearby-drivers", payload, {
      headers: authHeader(),
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

/**
 * Create a new ride booking
 * @param {{ passengerName, passengerMobile, pickup, drop, driverId, fare, paymentMode, bookedBy }} payload
 */
export async function createAdminBooking(payload) {
  try {
    const res = await API.post("/book-ride/create", payload, {
      headers: authHeader(),
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

/**
 * Get live status of a booked ride
 * @param {string} rideId
 */
export async function getBookingStatus(rideId) {
  try {
    const res = await API.get(`/book-ride/status/${rideId}`, {
      headers: authHeader(),
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

/**
 * Cancel an existing booking
 * @param {{ rideId, driverId, reason }} payload
 */
export async function cancelAdminBooking(payload) {
  try {
    const res = await API.post("/book-ride/cancel", payload, {
      headers: authHeader(),
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}